import { Refresh } from '@mui/icons-material';
import HighlightOff from '@mui/icons-material/HighlightOff';
import QrCodeIcon from '@mui/icons-material/QrCode';
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  Fab,
  Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import { QRCodeSVG } from 'qrcode.react';
import React, { useEffect, useState } from 'react';
import { generarTokenConsulta } from '../../services/Seo/OrdenDigital';
import CountDown from '../Common/CountDown';
import { useUser } from '../Auth/User';
import { LoadingButton } from '@mui/lab';
import backgroundQrFramework from '../../assets/images/svg/qr-framework.svg';

import AfiliadoSelect from '../Afiliados/AfiliadoSelect';
import { generarTokenFarmacia } from '../../services/Afiliado/Farmacia';

const TokenFarmaciaQr = ({
  open,
  qrValue,
  afiliado,
  handlerCerrarPreview = null,
  generarTokenFn = null,
  mensajeEspera = 'Esperando a que la farmacia escanee el código QR...',
  ...props
}) => {
  const { user } = useUser();
  const [caducado, setCaducado] = useState(false);
  const [Qr, setQr] = useState(qrValue);
  const [selectedAfiliado, setSelectedAfiliado] = useState(afiliado);
  const [fechaCreacionToken, setFechaCreacionToken] = useState(null);

  useEffect(() => {
    setQr(qrValue);
    setSelectedAfiliado(afiliado);
  }, [qrValue, afiliado]);

  const onCaducado = () => {
    setCaducado(true);
  };

  const handleClose = () => {
    handlerCerrarPreview();
  };

  const generarQr = async (idAfiliado) => {
   
    const getToken = await generarTokenFarmacia(idAfiliado);
    if (getToken) {
      setQr(getToken); 
    }
  };

  const onReload = (value) => {
    if(selectedAfiliado) {
      generarQr(selectedAfiliado.afiliado.idAfiliado);
      setCaducado(false);
      setQr(null);
    }
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={'sm'}
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent>
          <Stack direction='column' spacing={1} justifyContent='center' alignItems='center' gap={3}>
            {!Qr && <LoadingButton startIcon={<QrCodeIcon />} type='icon' loading={!Qr} />}

            {Qr && !caducado && (
             
              <Container>
                <Typography variant='h6' gutterBottom align='center'>
                  Token de Farmacia
                </Typography>
                <Typography variant='h6' gutterBottom align='center'>
                  {Qr}
                </Typography>
              </Container>
            )}
            {Qr && !caducado && (
             
              <Box
                sx={{
                  backgroundImage: `url("${backgroundQrFramework}")`,
                  width: '170px',
                  height: '170px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
              
                <QRCodeSVG value={JSON.stringify({ token: Qr })} />
              </Box>
            )}
            {Qr && caducado && (
             
              <Container>
                <Typography variant='h6' gutterBottom align='center'>
                  Token de Farmacia
                </Typography>
              </Container>
            )}

            {Qr && caducado && (
              
              <Fab
                color='default'
                aria-label='add'
                sx={{ height: 200, width: 200, p: 2 }}
                onClick={onReload}
              >
                <Stack direction='row' spacing={1} justifyContent='center' alignItems='center'>
                  <Refresh sx={{ fontSize: 60 }} />
                  
                  <Typography variant='caption'>Haz clic para actualizar el código QR</Typography>
                </Stack>
              </Fab>
            )}

            {!caducado && (
              <Container maxWidth='sm'>
                <Typography variant='subtitle2' align='center'>
                  {mensajeEspera}
                </Typography>

                <Stack direction='row' spacing={1} justifyContent='center' alignItems='center'>
                  <Typography variant='caption'> El código caducará en</Typography>
                  <CountDown id='count' minutes={5} onCaducado={onCaducado} />
                </Stack>
              </Container>
            )}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button
            size='small'
            startIcon={<HighlightOff />}
            variant='contained'
            color='neutral'
            onClick={(e) => handleClose(e)}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TokenFarmaciaQr;
